import Segment from './segment'
import wireNewsletterListeners from './listeners/newsletter'
import wireProductListeners from './listeners/products'
import wireSearchListeners from './listeners/search'
import wireCheckoutListeners from './listeners/checkout'
import wireDealerLocatorListeners from './listeners/dealerLocator'
import wireMyAccountListeners from './listeners/myAccount'
import wireSaveCartListeners from './listeners/saveCart'
import wireFitmentListeners from './listeners/fitment'
import wireInstallernetListeners from './listeners/installernet'
import wireNavigationListeners from './listeners/navigation'
import { wireExtendListeners } from './listeners/extend'

export default (ctx) => {
    /* eslint-disable */
    // prettier-ignore
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";}}();
    /* eslint-enable */

    ctx.$integrationsManager.loaders.onLoadLoader(() => {
        if (typeof window.analytics?.load === 'function')
            window.analytics.load(ctx.$sitewideData.config.segmentApiKey)
    })

    const segment = new Segment(ctx)
    wireCheckoutListeners(segment, ctx)
    wireExtendListeners(segment, ctx)
    wireFitmentListeners(segment, ctx)
    wireDealerLocatorListeners(segment, ctx)
    wireMyAccountListeners(segment, ctx)
    wireNewsletterListeners(segment, ctx)
    wireProductListeners(segment, ctx)
    wireSaveCartListeners(segment, ctx)
    wireSearchListeners(segment, ctx)
    wireInstallernetListeners(segment, ctx)
    wireNavigationListeners(segment, ctx)

    const { $uiEvents } = ctx

    // Default/Generic Listeners
    $uiEvents.$on('firstLoaded', ({ to }) => segment.emitPage(to))
    $uiEvents.$on('firstLoaded', () => segment.emitIdentify())
    $uiEvents.$on('routeChanged', ({ to }) => segment.emitPage(to))
    $uiEvents.$on('errorLog', ({ errorType }) => segment.track('Error Log', { errorType }))
    $uiEvents.$on('cmsLinkClicked', (obj) => segment.track('Clicked', obj))

    $uiEvents.$on('amplitudeExposure', (exposure) => segment.track('$exposure', exposure))

    // A/B TESTS - This code has changed in a PR that has not been merged yet
    // but will move to its own file after that.
    $uiEvents.$on('experimentViewed', (exp) =>
        segment.track('Experiment Viewed', {
            exp,
        })
    )

    $uiEvents.$on('deviceChanged', emitDeviceChanged)
    // Fires when deviceFromServer !== clientDevice
    let isDebounced = false // When going from D-top to Mobile this event will fire for both Small and Mobile.
    function emitDeviceChanged(device) {
        if (isDebounced) return
        isDebounced = true
        const screenDimensions = window.screen
            ? `${window.screen.width}x${window.screen.height}`
            : `${window.innerWidth}x${window.innerHeight}`

        segment.track('Device Changed', {
            changed: `${device.from} -> ${device.to}`,
            device: `${screenDimensions} / ${window.navigator.userAgent}`,
        })
        setTimeout(() => (isDebounced = false), 1000)
    }

    // This is only used by the smsSubscription method in
    // /pages/checkout/receipt/index.vue
    return { getAnonId: () => segment.getAnonId() }
}
